import api, { FILE_URL } from "./api";

export const UploadFile = async (file) => {
  return await api.post(`${FILE_URL}/`, file);
};

export const postTeacherMediaURL = async (url, type, teacherId) => {
  return await api.post(`/teacherMedia`, { url, type, teacherId });
};

export const getTeacherMedias = async (teacherId) => {
  return await api.get(`/teachers/${teacherId}/media`);
};

//
export const deleteFile = async (url) => {
  return await api.delete(`${FILE_URL}?path=${url}`);
};
